import { Images } from "@assets/assets";
import Image from "next/image";

export default function TeamHRD() {
  return (
    <section className="relative z-2 overflow-hidden ">
      <div className="absolute inset-0 z-0">
        <Image
          src={Images?.texture}
          alt="texture"
          fill
          className="object-cover mix-blend-overlay opacity-60"
          sizes="(max-width: 768px) 100vw, (max-width: 1536px) 50vw, 700px"
        />
      </div>
      <div className="absolute inset-0 bg-[#0C41B2]" />

      <div
        className="pointer-events-none absolute inset-0 flex items-center justify-center"
        aria-hidden="true"
      >
        <div className="relative h-[80%] aspect-[1/1]">
          <div
            className={`absolute inset-0 rounded-full border border-[rgba(255,255,255,0.2)]`}
          ></div>
          <div className="absolute inset-0 rounded-full overflow-hidden">
            <div className="absolute inset-0 origin-center animate-[spin_4.5s_linear_infinite]">
              <div
                className={`absolute bottom-0 left-1/2 -translate-x-1/2 w-[140%] h-1/2 bg-gradient-to-t from-[#0C41B2] via-[#0C41B2]/70 to-transparent`}
              ></div>
            </div>
          </div>

          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[60%] aspect-[1/1]">
            <div
              className={`absolute inset-0 rounded-full border border-[rgba(255,255,255,0.2)]`}
            ></div>
            <div className="absolute inset-0 rounded-full overflow-hidden">
              <div className="absolute inset-0 origin-center animate-[spin_4.5s_linear_infinite]">
                <div
                  className={`absolute bottom-0 left-1/2 -translate-x-1/2 w-[140%] h-1/2 bg-gradient-to-t from-[#0C41B2] via-[#0C41B2]/70 to-transparent`}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative z-10 max-w-[2500px] mx-auto w-[calc(100%_-_10%)] lg:py-[150px] py-[50px]">
        <div className="flex flex-col xl:flex-row items-start lg:justify-between gap-10">
          {/* Left copy */}
          <div className="flex-1 text-white lg:max-w-[820px] xl:max-w-[880px]">
            <p className="uppercase tracking-[0.12em] text-[15px]  text-white/70">
              Hey! Come and join us!
            </p>
            <h2 className="mt-3 clash-font font-medium leading-[100%] text-[length:var(--section-title)]">
              Be a part of the most &nbsp;
              <br className="hidden lg:block" />
              happening team &nbsp;
              <br className="hidden lg:block" />
              around!
            </h2>
            <p className="mt-5 lg:mt-10 text-white/80 max-w-[70ch] text-[length:var(--hero-para)] leading-[150%]">
              We are hunting expert web and app developers, ingenious graphic
              designers and solution-oriented project managers to work with us
              on the various challenging and innovative projects of our clients.
              If you are ready to become a part of our brainy, tech-savvy team,
              get in touch with us now.
            </p>
          </div>

          {/* Right card */}
          <div className="w-full max-w-[max-content] lg:max-w-[470px] relative">
            <div className="bg-white shadow-[0_10px_50px_rgba(12,65,178,0.2)] p-8 md:p-10">
              <div className="flex items-center gap-5">
                <Image
                  src={Images?.career.logoStamp}
                  alt="Konstant Logo Stamp"
                  className="w-[120px] h-[120px] object-contain"
                  width={96}
                  height={96}
                  sizes="(max-width: 768px) 100vw, (max-width: 1536px) 50vw, 700px"
                />
                <div className="text-[#000] font-medium text-[length:var(--industry-title)] leading-[100%] clash-font">
                  Team HRD
                </div>
              </div>

              <div className="mt-8 grid gap-6">
                {/* Contact Number */}
                <div className="flex items-center gap-4">
                  <span className="inline-flex items-center justify-center w-10 h-10 rounded-md bg-[#0C41B2]/10">
                    <Image
                      src={Images?.career.phoneFill}
                      alt="phone"
                      className="w-6 h-6"
                      width={32}
                      height={32}
                      sizes="(max-width: 768px) 100vw, (max-width: 1536px) 50vw, 700px"
                    />
                  </span>
                  <div>
                    <div className="text-[#0B0F17]/70">Contact Number</div>
                    <div className="text-[#0B0F17] font-[700]">
                      <a href="tel:+911412291398">+91-141-2291398</a>,
                      <a href="tel:+919521459709">9521459709</a>
                    </div>
                  </div>
                </div>

                {/* Email Address */}
                <div className="flex items-center gap-4">
                  <span className="inline-flex items-center justify-center w-10 h-10 rounded-md bg-[#0C41B2]/10">
                    <Image
                      src={Images?.career.mail}
                      alt="email"
                      className="w-6 h-6"
                      width={32}
                      height={32}
                      sizes="(max-width: 768px) 100vw, (max-width: 1536px) 50vw, 700px"
                    />
                  </span>
                  <div>
                    <div className="text-[#0B0F17]/70">Email Address</div>
                    <a href="mailto:career@konstantinfo.com">
                      career@konstantinfo.com
                    </a>
                  </div>
                </div>
              </div>
            </div>
            {/* floating text pointer */}
            <Image
              src={Images?.career.floatingText}
              alt="Connect directly with the Recruiter"
              className="hidden xl:block absolute translate-x-[-100%] translate-y-[130%] left-[0%] bottom-[0px] w-[220px]"
              width={220}
              height={220}
              sizes="(max-width: 768px) 100vw, (max-width: 1536px) 50vw, 700px"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
